module.exports = __webpack_public_path__ + "img/wool_mob.2cc162d.webp";